import { builderFragment } from './fragments.gql'

export default `query {
  giftingPage {
    ${builderFragment}
  }
}`
